import { useEffect } from 'react';

import { useCsvDownloadContext } from '@/components/Chart/context/CsvTableContext';

const useCsvDownload = (from: string | undefined, downloadFileId: string | undefined) => {
  const { setDownloadFileId, setSelectedRange } = useCsvDownloadContext();
  useEffect(() => {
    if (downloadFileId && downloadFileId.length > 0) {
      setDownloadFileId(downloadFileId);
      if (from && from.length > 0) {
        setSelectedRange(from);
      }
    }
  }, [from, downloadFileId]);

  return {};
};

export default useCsvDownload;
